import axios from '../../axios/index.js'

export default {
    vendorExpenses(data) {
        return axios.post('vendors/details', data)
    },
    vendorCheck(data) {
        return axios.post('vendors/check', data)
    },
    getData(data) {
        return axios.get('vendors/getData', { params:data })
    },
    getCardsData(data) {
        return axios.get('vendors/getCardsData', { params:data })
    },
    createExpense(data) {
        return axios.post('vendors-portal/create_expense', data)
    },
    uploadFiles(data) {
        return axios.post('vendors-portal/upload_files', data)
    },
    getRepseDocumentation(data) {
        return axios.get('vendors/repse/documentation',{ params:data })
    },
    getRepseRequests(id) {
        return axios.get('vendors/repse/requests/' + id)
    },
    repseUpdateFile(data) {
        return axios.post('repse/vendors/updateFile/AIKwkshj-Ai820Gkt-065iEksu-EK', data, {
            headers: { 'Content-Type': 'multipart/form-data' },
            processData: false,
            contentType: false
          })
    },
    getRepseAlert(rfc){
        return axios.get('repse/vendor/pendingDocumentation/'+ rfc)
    }
}
